import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import Box from "@amzn/meridian/esm/components/box";
import Row from "@amzn/meridian/esm/components/row";
import Theme from "@amzn/meridian/esm/components/theme";
import "./Summaries.css";
import { sampleSummaryList } from "../../../localtest/LocalhostTest";
import SummaryCard from "../../common/summary/SummaryCard";
import { fetchSummaries, generateSummaryGroup } from "../../utils/SummaryUtil";

import NoSummary from "./NoSummary";
import Loading from "../../common/Loading";
import CommonErrorModal from "../../common/error/CommonErrorModal";

const Summaries = () => {
  const navigate = useNavigate();
  const [summaryGroups, setSummaryGroups] = useState({});
  const [isSummaryEmpty, setIsSummaryEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showServerError, setShowServerError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);

  useEffect(() => {
    if (window.location.href === "http://localhost:3000/") {
      console.info("[Localhost] Running in localhost. Using sampleSummaryList.");
      setIsSummaryEmpty(false);
      const groups = generateSummaryGroup(sampleSummaryList);
      setSummaryGroups(groups);
      setIsLoading(false);
    } else {
      fetchSummaries()
        .then((summaryListJson) => {
          if (summaryListJson.length > 0) {
            const groups = generateSummaryGroup(summaryListJson);
            setSummaryGroups(groups);
            setIsSummaryEmpty(false);
          } else {
            setIsSummaryEmpty(true);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setShowServerError(true);
          setIsLoading(false);
        });
    }
  }, []);

  const onViewMoreClick = (summaryData) => {
    navigate(`/meeting/summary/${summaryData.aimsUuid}`, { state: { summary: summaryData } });
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : showServerError ? (
        <CommonErrorModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      ) : isSummaryEmpty ? (
        <NoSummary />
      ) : (
        <Theme tokens={{ boxBorderColorOutline: "#CCD5DE" }}>
          <div className="box-with-background" style={{ width: "370px", height: "90vh" }}>
            <Row spacing="none" spacingInset="none">
              <Row width="32px" />
              <Box width="326px" height="90vh" spacing="none" spacingInset="none" overflowY="scroll">
                <Column spacing="none" spacingInset="none">
                  {Object.entries(summaryGroups).map(([groupTitle, summaries]) => (
                    <Box key={groupTitle} width="326px" marginBottom="space100">
                      <Column height="16px" />
                      <Text type="h100">{groupTitle}</Text>
                      <Column height="16px" spacing="none" spacingInset="none" />
                      <Column spacing="none" spacingInset="none">
                        {summaries.map((summary) => (
                          <Column key={summary.aimsUuid} spacing="none" spacingInset="none">
                            <SummaryCard summary={summary} onViewMoreClick={onViewMoreClick} />
                            <Column height="12px" />
                          </Column>
                        ))}
                      </Column>
                    </Box>
                  ))}
                </Column>
              </Box>
            </Row>
          </div>
        </Theme>
      )}
    </>
  );
};

export default Summaries;
